import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Divider, Flex, Form, Input, Select } from "antd";

export default function RenderSelect(props) {
	const { namePath = [], form_question_options = [], required = false } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	const [options, setOptions] = useState(
		form_question_options.filter((x) => !x.is_other).length
			? form_question_options
					.filter((x) => !x.is_other)
					.map((item, index) => ({
						key: index,
						value: item.option,
						label: item.option,
					}))
			: []
	);
	const [otherValue, setOtherValue] = useState("");

	let findOther = form_question_options.find((option) => option.is_other);

	return (
		<Form.Item
			name={newNamePath}
			rules={[
				{
					required: required ? true : false,
					message: "This field is required!",
				},
			]}
		>
			<Select
				placeholder="Select an answer"
				size="large"
				allowClear
				showSearch
				options={options}
				popupRender={
					findOther
						? (menu) => (
								<>
									{menu}
									<Divider style={{ margin: "5px 0" }} />
									<Form.Item shouldUpdate noStyle>
										{({ setFieldValue }) => {
											return (
												<Flex style={{ padding: "0 8px 4px" }}>
													<Input
														placeholder="Add new option"
														value={otherValue}
														onChange={(e) => setOtherValue(e.target.value)}
														onKeyDown={(e) => e.stopPropagation()}
													/>
													<Button
														type="text"
														icon={<FontAwesomeIcon icon={faPlus} />}
														onClick={() => {
															if (otherValue.trim()) {
																setOptions((prevOptions) => [
																	...prevOptions,
																	{
																		key: prevOptions.length,
																		value: otherValue,
																		label: otherValue,
																	},
																]);

																setFieldValue(newNamePath, otherValue);

																setOtherValue("");
															}
														}}
													/>
												</Flex>
											);
										}}
									</Form.Item>
								</>
						  )
						: undefined
				}
			/>
		</Form.Item>
	);
}
